module.exports = __webpack_public_path__ + "static/media/physical_damage.6cdfa464.svg";